'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    font-size: 34px;\n  '], ['\n    font-size: 34px;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-size: 16px;\n  '], ['\n    font-size: 16px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    text-align: left;\n    padding: 0 15px;\n  '], ['\n    text-align: left;\n    padding: 0 15px;\n  ']);

var _colors = require('HubStyleTokens/colors');

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Tabs = require('./Tabs');

var _Tabs2 = _interopRequireDefault(_Tabs);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _reactRouterDom = require('react-router-dom');

var _responsiveBreakpoints = require('../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PricingPageTitle = _styledComponents2.default.h1.withConfig({
  displayName: 'TabLayout__PricingPageTitle'
})(['font-size:28px;color:', ';', ''], _colors.OLAF, _responsiveBreakpoints2.default.tablet(_templateObject));

var PricingPageSubtitle = _styledComponents2.default.p.withConfig({
  displayName: 'TabLayout__PricingPageSubtitle'
})(['font-size:14px;color:', ';.pricing-page-subtitle-link{text-decoration:underline;color:', ';}', ';'], _colors.OLAF, _colors.OLAF, _responsiveBreakpoints2.default.tablet(_templateObject2));

var HeaderTitle = _styledComponents2.default.div.withConfig({
  displayName: 'TabLayout__HeaderTitle'
})(['text-align:center;', ''], _responsiveBreakpoints2.default.phone(_templateObject3));

var HeaderGradient = _styledComponents2.default.div.withConfig({
  displayName: 'TabLayout__HeaderGradient'
})(['position:absolute;z-index:-100;background-color:#00bda5;background-image:linear-gradient( -303deg,', ',0%,#00afb2 56%,', ' 100% );width:100%;height:100%;'], _colors.CALYPSO, _colors.OZ);

var HeaderLink = function HeaderLink(_ref) {
  var history = _ref.history,
      children = _ref.children;

  return _react2.default.createElement(
    _UILink2.default,
    {
      className: 'pricing-page-subtitle-link',
      onClick: function onClick() {
        history.push('/crm');
      }
    },
    children
  );
};

HeaderLink = (0, _reactRouterDom.withRouter)(HeaderLink);

function HeaderBackdrop() {
  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(HeaderGradient, null),
    _react2.default.createElement(
      HeaderTitle,
      { className: 'm-auto-y-0' },
      _react2.default.createElement(
        PricingPageTitle,
        { className: 'p-top-13 p-bottom-2 m-bottom-0' },
        _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.title' })
      ),
      _react2.default.createElement(
        PricingPageSubtitle,
        { className: 'p-bottom-13 m-bottom-0' },
        _react2.default.createElement(_FormattedJSXMessage2.default, {
          elements: { HeaderLink: HeaderLink },
          message: 'pricingPage.subTitle_jsx'
        })
      )
    )
  );
}

function TabLayout(_ref2) {
  var selectedPrimaryTab = _ref2.selectedPrimaryTab,
      selectedSecondaryTab = _ref2.selectedSecondaryTab,
      children = _ref2.children;

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(HeaderBackdrop, null),
    _react2.default.createElement(_Tabs2.default, {
      selectedPrimaryTab: selectedPrimaryTab,
      selectedSecondaryTab: selectedSecondaryTab
    }),
    children
  );
}

exports.default = TabLayout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/TabLayout.js
// module id = 145
// module chunks = 3 4